<template>
  <section class="section container pt-0">
    <datasource-datatable />
  </section>
</template>

<script>
import DatasourceDatatable from "./datasource_datatable/Index.vue";
export default {
  name: "DatasourceIndex",
  components: {
    DatasourceDatatable,
  },
  data() {
    return {};
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
